<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default full-modal-tabs" [disableRipple]="true">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>General</span>
          <mat-badge
            *ngIf="getGeneralFormErrors() as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>

        <div class="form-group">
          <label for="{{ baseId }}-id" translate>ID</label>
          <input
            id="{{ baseId }}-id"
            class="form-control"
            [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
            type="text"
            formControlName="externalId"
          />
          <div *ngIf="showErrors(externalIdControl, isSubmitted)" id="{{ baseId }}-warning-text-id" class="incorrect-input" translate>
            {{ externalIdControl.errors | fcListValidation : 'ID' }}
          </div>
        </div>

        <div class="form-group">
          <label for="{{ baseId }}-name" translate>Name</label>
          <input
            id="{{ baseId }}-name"
            class="form-control"
            [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
            type="text"
            formControlName="name"
          />
          <div *ngIf="showErrors(nameControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-name" translate>
            {{ nameControl.errors | fcListValidation : 'Name' }}
          </div>
        </div>

        <div class="form-group full-control">
          <label for="{{ baseId }}-notes" translate>Notes</label>
          <textarea
            class="form-control"
            [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
            id="{{ baseId }}-notes"
            formControlName="notes"
            rows="3"
          >
          </textarea>
          <div *ngIf="showErrors(notesControl, isSubmitted)" id="{{ baseId }}-warning-text-notes" class="incorrect-input" translate>
            {{ notesControl.errors | fcListValidation : 'Notes' }}
          </div>
        </div>

        <div class="checkbox-group">
          <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive</mat-checkbox>
          <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate> User Defined</mat-checkbox>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Security</span>
          <mat-badge
            *ngIf="getSecurityErrors() as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <table class="table emds-table table-sticky-header table-striped">
          <thead>
            <tr>
              <th translate>User or User Group</th>
              <th translate>New</th>
              <th translate>Modify</th>
              <th translate>Delete</th>
              <th></th>
            </tr>
          </thead>
          <tbody formArrayName="relMacroGroupSecurityList">
            <tr *ngFor="let securityUserGroupForm of securityTabFormArray.controls; let i = index" [formGroup]="securityUserGroupForm">
              <td>
                <div id="{{baseId}}-user-usergroup-{{i}}">
                  <ap-findcontrol [baseId]="baseId + '-' + i + '-user-or-usergroup'"
                    [findControlId]="findControlIdService.ViewUserAndUserGroup"
                    [(selectedPk)]="userOrUserGroupIds[i]"
                    [findControlDisplayName]="'User or User Group'"
                    [apFormGroup]="securityUserGroupForm"
                    [controlName]="userOrUserGroupUidFormControlName"
                    [singleSelect]="true"
                    [form]="form"
                    [required]="true"
                    [disabled]="isSecurityEditDisabled()">
                  </ap-findcontrol>
                </div>
              </td>
              <td>
                <div class="td-center">
                  <mat-checkbox formControlName="isNewSelectedFormControl">
                  </mat-checkbox>
                </div>
              </td>
              <td>
                <div class="td-center">
                  <mat-checkbox formControlName="isModifySelectedFormControl">
                  </mat-checkbox>
                </div>
              </td>
              <td>
                <div class="td-center">
                  <mat-checkbox formControlName="isDeleteSelectedFormControl">
                  </mat-checkbox>
                </div>
              </td>
              <td>
                <div class="td-center">
                  <ng-container *ngIf="isSecurityEditDisabled() === false">
                    <mat-icon class="clickable" (click)="deleteRow(i)">close</mat-icon>
                  </ng-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-container *ngIf="isSecurityEditDisabled() === false">
          <mat-icon class="clickable" (click)="addRow()">add_circle</mat-icon>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</fc-general-modal>
